// extracted by mini-css-extract-plugin
export var closeButton = "_1z-3";
export var header = "_1z-0";
export var link = "_1z-1";
export var retryButton = "_1z-2";